import type { PaymentType } from '#src/app/shared/utils/payments';

const WALLET_PAYMENTS = ['paypal', 'applePay', 'googlePay'];

export function useCanUserUpdateFields(): (paymentType: PaymentType) => boolean {
	return (paymentType: PaymentType) => {
		return !WALLET_PAYMENTS.includes(paymentType);
	};
}
